/**
 * Photo-first driver license verification flow.
 *
 * Uses the same state machine as identity verification (Didit supports
 * licenses via /v3/id-verification/ in 220+ countries). Wraps
 * useDocumentVerificationStep with the license-specific submit path.
 */
import { useCallback } from 'react'
import { verificationService } from '@/lib/services/verification.service'
import { useDocumentVerificationStep } from './use-document-verification-step'

interface Options {
  userId: string | null
  issuingCountry: string
}

export function useLicenseVerification(opts: Options) {
  const step = useDocumentVerificationStep({
    requireBack: true, // Salvadoran + most licenses have info on both sides
    submit: useCallback(
      async ({ frontImageUri, backImageUri }) => {
        if (!opts.userId) {
          throw new Error('Not authenticated')
        }
        return verificationService.submitAndVerifyLicense(opts.userId, {
          issuingCountry: opts.issuingCountry,
          frontImageUri,
          backImageUri: backImageUri ?? undefined,
        })
      },
      [opts.userId, opts.issuingCountry],
    ),
  })

  return step
}
